// useBreadcrumbPagination.js
import { useState, useEffect } from 'react';

export const useBreadcrumbPagination = (initialTotalRecords = 0, initialRowsPerPage = 25) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    setTotalPages(Math.ceil(initialTotalRecords / rowsPerPage));
  }, [initialTotalRecords, rowsPerPage]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
  };

  return {
    page,
    rowsPerPage,
    totalPages,
    handleChangePage,
    handleChangeRowsPerPage
  };
};
